
@if (formChat) {

  <div class="chat-container-border">
    <div class="chat-top u-flex u-flex-align-items-center" (click)="getSmallChat()">
      <div class="contract-btn u-flex u-flex-justify-content-center u-flex-align-items-center">
        <span class="bold">{{'CHAT.MINIMIZE' | translate}}</span>
        <i class="icon-close"></i>
      </div>
    </div>
    <form class="chat-body" [formGroup]="formChat" (keyup.enter)="onSubmit($event)"
      (keydown.enter)="preventNewLine($event)">
      <!-- DIV MENSAJES CHAT -->
      <div class="messages-container" #msgHistory [scrollTop]="msgHistory.scrollHeight">
        <ul>

          @for(message of chatMessages; track $index){
          <li [ngClass]="'row-' + message.owner">
            <div class="msg-inner"
              [ngStyle]="message.owner === 'mine'?{'border-left': 'none'} : {'border-left': message.color}">
              @if (message.name){
                <div [ngClass]="'name-' + message.owner">
                  {{message.name}}
                </div>
              }
              @if (message.text){
                <div [ngClass]="message.owner">
                  {{message.text}}
                </div>
              }
              @if (message.img){
                <span>
                  <img [src]="message.img" (click)="openFile(message)">
                </span>
              }
              
              @if (message.doc){
                <div [ngClass]="message.owner" class="doc-file">
                  <div class="icon-text-file-container">
                    <i class="icon-down" (click)="openFile(message)"></i>
                    <div (click)="openFile(message)">{{message.fileName}}</div>
                  </div>
                </div>
              }

            </div>
          </li>
          }

        </ul>

        @if(showAlertTypeFile){
          <div class="error-doc u-flex u-flex-justify-content-between">
            <div class="alert-txt">{{ 'CHAT.ERROR_TYPE_FILE' | translate:{ types: errorTypesText } }}</div>
            <i class="icon-close" (click)="toggleAlertTypeFile()"></i>
          </div>
        }
      </div>
      <!-- DIV MENSAJE ARCHIVO SUBIDO -->
      <div class="control-container">
        <div [ngClass]="{'show-uploading-message': loadingFile || selectionFile}" class="uploading-message">
          <span>{{ (selectionFile? 'CHAT.SELECTING_FILE' : 'CHAT.UPLOADING_FILE') | translate}}</span>
          @if (!selectionFile){
            <svg class="icon-spinner" viewBox="0 0 50 50">
              <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
            </svg>
          }
        </div>
        @if(showAlertSizeFile){
          <!-- DIV MENSAJE ALERTA -->
          <div class="alert u-flex u-flex-justify-content-between">
            <i class="icon-atention"></i>
            <div class="alert-txt">{{ 'CHAT.ERROR_MAX_SIZE_FILE' | translate:{ size: maxMBSizeFile } }}</div>
            <i class="icon-close" (click)="toggleAlertSizeFile()"></i>
          </div>
        }
        <!-- INPUT TEXTO CHAT -->
        <div class="insert-text-container">
          <textarea type="text" class="form-control" id="text" formControlName="textChat" placeholder=""
            autocomplete="off"></textarea>
          <div class="send-btn" (click)="onSubmit($event)">
            <i class="icon-arrow"></i>
          </div>
        </div>
  
        <!-- INPUT SYUBIDA ARCHIVA -->
         @if (features.upload_file_chat){
           <div  class="upload-file-container">
             <div class="u-flex u-flex-align-items-center u-width-100">
               <i class="icon-up"></i>
               <div class="upload-file-txt">
                 {{'CHAT.UPLOAD_FILE' | translate}}
               </div>
             </div>
             <input type="file" class="custom-file-input" id="file" (click)="selectFile($event)" (change)="addFiles($event)"
               formControlName="file" accept="{{ typesFile }}" />
           </div>
         }
      </div>
    </form>
  </div>
}
